import { IconPickerSection } from './icon-picker-section';

export interface IconPickerConfig {
  sections: IconPickerSection[];
}
